{
  "products": [
    {
      "id": "patch-slava-ukraine-fundraiser",
      "name": "Slava Ukraine Fundraiser Patch",
      "price": "£1",
      "category": "accessory",
      "mainImage": "slava-ukraine-fundraiser",
      "gallery": ["slava-ukraine-fundraiser"],
      "freeShipping": true
    },
    {
      "id": "patch-fuck-putin",
      "name": "Fuck Putin Patch",
      "price": "£5",
      "category": "accessory",
      "mainImage": "fuck-putin",
      "gallery": ["fuck-putin"]
    },
    {
      "id": "patch-scotland-ukraine",
      "name": "Scotland Ukraine Patch",
      "price": "£5",
      "category": "accessory",
      "mainImage": "scotland-ukraine",
      "gallery": ["scotland-ukraine"]
    },
    {
      "id": "patch-scottish-metal-fundraiser",
      "name": "Scottish Metal Fundraiser Patch",
      "price": "£5",
      "category": "accessory",
      "mainImage": "scottish-metal-fundraiser",
      "gallery": ["scottish-metal-fundraiser"]
    },
    {
      "id": "patch-stand-with-ukraine",
      "name": "Stand With Ukraine Patch",
      "price": "£5",
      "category": "accessory",
      "mainImage": "stand-with-ukraine",
      "gallery": ["stand-with-ukraine"]
    },
    {
      "id": "patch-ukraine-crest",
      "name": "Ukraine Crest Patch",
      "price": "£5",
      "category": "accessory",
      "mainImage": "ukraine-crest",
      "gallery": ["ukraine-crest"]
    },
    {
      "id": "glass-1",
      "name": "Glass 1",
      "price": "£25",
      "category": "accessory",
      "mainImage": "ukraine-trident",
      "gallery": ["ukraine-trident"]
    },
    {
      "id": "glass-2",
      "name": "Glass 2",
      "price": "£25",
      "category": "accessory",
      "mainImage": "ukraine-metal-trident",
      "gallery": ["ukraine-metal-trident"]
    },
    {
      "id": "glass-3",
      "name": "Glass 3",
      "price": "£25",
      "category": "accessory",
      "mainImage": "ukraine-metal-trident-3",
      "gallery": ["ukraine-metal-trident-3"]
    },
    {
      "id": "t-shirt",
      "name": "T shirt",
      "price": "£20",
      "category": "apparel",
      "mainImage": "metal-for-ukraine",
      "gallery": ["metal-for-ukraine"]
    },
    {
      "id": "doll-10cm",
      "name": "10cm doll",
      "price": "£10",
      "category": "accessory",
      "mainImage": "ukrainian-doll-small",
      "gallery": ["ukrainian-doll-small"]
    },
    {
      "id": "doll-15cm",
      "name": "15cm doll",
      "price": "£20",
      "category": "accessory",
      "mainImage": "ukrainian-doll-big",
      "gallery": ["ukrainian-doll-big"]
    }
  ]
}
